// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v5vFzaLoHym48ZlQ0hse {
  display: block;
}

.eyDdB5dMhHvQOF39nmW9 {
  max-height: 100%;
}

.SW1mF7d6JaiCU2lCwQYR {
  padding: 2.5rem 0 0 2.5rem;
  height: auto;
  justify-content: space-between;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .ffd_HqdyfNrhJHTw92Qh {
    position: relative;
    left: -1.5rem;
    width: calc(100% + 3rem);
    padding: 0 1.5rem 1rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .ffd_HqdyfNrhJHTw92Qh {
    position: relative;
    font-weight: 800;
    font-size: 1.0625rem;
    line-height: 1.3125rem;
    font-family: var(--heading-font-family);
  }

  .vbh9B0Lcz4J5j_ebFvJa {
    margin-top: 0;
    border-radius: 0;
  }

  .SW1mF7d6JaiCU2lCwQYR {
    padding: 0;
    justify-content: center;
  }

  .HVCriPxdM0_axY8GH8pv {
    right: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StoreSwitcherModal/StoreSwitcherModal.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;;EACE;IACE,kBAAkB;IAClB,aAAW;IACX,wBAAwB;IACxB,sBAAoB;EACtB;AACF;;AAEA;;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,oBAAe;IACf,sBAAiB;IACjB,uCAAuC;EACzC;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".storeSwitcherModal {\n  display: block;\n}\n\n.modalContentClassName {\n  max-height: 100%;\n}\n\n.modalHeaderClassName {\n  padding: 40px 0 0 40px;\n  height: auto;\n  justify-content: space-between;\n}\n\n@media (--tablet) {\n  .languageFormTitle {\n    position: relative;\n    left: -24px;\n    width: calc(100% + 48px);\n    padding: 0 24px 16px;\n  }\n}\n\n@media (--mobile) {\n  .languageFormTitle {\n    position: relative;\n    font-weight: 800;\n    font-size: 17px;\n    line-height: 21px;\n    font-family: var(--heading-font-family);\n  }\n\n  .modalContentWrapperClassName {\n    margin-top: 0;\n    border-radius: 0;\n  }\n\n  .modalHeaderClassName {\n    padding: 0;\n    justify-content: center;\n  }\n\n  .closeBtnClassName {\n    right: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"storeSwitcherModal": `v5vFzaLoHym48ZlQ0hse`,
	"modalContentClassName": `eyDdB5dMhHvQOF39nmW9`,
	"modalHeaderClassName": `SW1mF7d6JaiCU2lCwQYR`,
	"languageFormTitle": `ffd_HqdyfNrhJHTw92Qh`,
	"modalContentWrapperClassName": `vbh9B0Lcz4J5j_ebFvJa`,
	"closeBtnClassName": `HVCriPxdM0_axY8GH8pv`
};
export default ___CSS_LOADER_EXPORT___;
